import React, { useEffect } from "react";
import { Button, Dropdown, Menu, message, Modal, Tooltip } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import {
  createComponentStore,
  useStoreActions,
  useStoreState,
} from "easy-peasy";
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RECORD_STATE } from "Constants";
import UserStoreModel, { ACTION_TYPES } from "store/models/user";
import { ACTION_TYPES as AUTH_ACTION_TYPES } from "store/models/auth";

const useStore = createComponentStore(UserStoreModel);

export default function OperationsColumn({
  record,
  onOperationExecuted,
  ...props
}) {
  const history = useHistory();
  const match = useRouteMatch();

  const { abilities, process } = useStoreState((store) => store.auth);
  const { forgotPassword } = useStoreActions((store) => store.auth);

  const [store, actions] = useStore();

  useEffect(() => {
    switch (store.process) {
      case ACTION_TYPES.USER_CONFIRMED:
        message.success("Kullanıcı onayladı.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_LOCKED:
        message.success("Kullanıcı kilitlendi.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_UNLOCKED:
        message.success("Kullanıcı kilidi açıldı.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_CREATED:
        message.success("Kullanıcı oluşturuldu.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_UPDATED:
        message.success("Kullanıcı güncellendi.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_DELETED:
        message.success("Kullanıcı arşivlendi.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.USER_RESTORED:
        message.success("Kullanıcı arşivden geri alındı.");
        onOperationExecuted();
        break;
      default:
        break;
    }
  }, [store.process]);

  useEffect(() => {
    if (process === AUTH_ACTION_TYPES.SENT_PASSWORD_RESET_MAIL) {
      message.success("Kullanıcıya şifre sıfırlama e-postası gönderildi.");
    }
  }, [process]);

  const handleActions = (key, record) => {
    switch (key) {
      case "detail":
        if (record.state === RECORD_STATE.ACTIVE)
          history.push(`${match.path}/${record.id}/detay`);
        else history.push(`${match.path}/${record.id}/arsiv`);
        break;
      case "edit":
        history.push(`${match.path}/${record.id}/duzenle`);
        break;
      case "reset-password":
        forgotPassword({ email: record.email });
        break;
      case "confirm":
        actions.confirmUser({ id: record.id });
        break;
      case "lock":
        actions.lockUser({ id: record.id });
        break;
      case "unlock":
        actions.unLockUser({ id: record.id });
        break;
      case "remove":
        actions.deleteUser({ id: record.id, version: record.version });
        break;
      case "restore":
        actions.restoreUser({ id: record.id, version: record.version });
        break;
      default:
        break;
    }
  };

  return (
    <Dropdown
      trigger="click"
      placement="bottomRight"
      overlay={
        <Menu onClick={(item) => handleActions(item.key, record)}>
          <Menu.Item key="detail">
            <FontAwesomeIcon
              icon={["far", "eye"]}
              style={{ marginRight: 8, width: 24 }}
            />
            Görüntüle
          </Menu.Item>

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Kullanıcı Listesi") && (
              <Menu.Item key="edit">
                <FontAwesomeIcon
                  icon={["far", "edit"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Düzenle
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Kullanıcı Listesi") && (
              <Menu.Item key="reset-password">
                <FontAwesomeIcon
                  icon={["fas", "key"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Şifre Sıfırla
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Kullanıcı Listesi") &&
            !record.confirmed && (
              <Menu.Item key="confirm">
                <FontAwesomeIcon
                  icon={["fas", "user-check"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Onayla
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Kullanıcı Listesi") && (
              <Menu.Item key={record.locked ? "unlock" : "lock"}>
                <FontAwesomeIcon
                  icon={["fas", record.locked ? "lock-open" : "user-lock"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                {record.locked ? "Kilidi Aç" : "Kilitle"}
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.ACTIVE &&
            AuthCheck(abilities, AUTH_ACTIONS.DELETE, "Kullanıcı Listesi") && (
              <Menu.Item key="remove">
                <FontAwesomeIcon
                  icon={["far", "trash-alt"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Sil
              </Menu.Item>
            )}

          {record.state === RECORD_STATE.DELETED &&
            AuthCheck(
              abilities,
              AUTH_ACTIONS.RESTORE_ARCHIVE,
              "Kullanıcı Listesi"
            ) && (
              <Menu.Item key="restore">
                <FontAwesomeIcon
                  icon={["fas", "recycle"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Geri Al
              </Menu.Item>
            )}
        </Menu>
      }
    >
      <Button>
        <FontAwesomeIcon icon={["fas", "ellipsis-h"]} />
      </Button>
    </Dropdown>
  );
}
